/**
 * Initial-in-a-circle avatar. There is no photo source for community members
 * — and there deliberately will not be one — so the first letter is the
 * identity marker throughout, exactly as the Inbox mockup does it. Colour is
 * derived from the name so a given person always looks the same.
 */
const PALETTE = [
  { bg: "#FDF1E5", fg: "#C2620F" },
  { bg: "#E8EFFD", fg: "#2551B8" },
  { bg: "#E7F7ED", fg: "#12793A" },
  { bg: "#EFE9FD", fg: "#5B2FB8" },
  { bg: "#FDECEC", fg: "#B92222" },
  { bg: "#FDF3E2", fg: "#A65C05" },
  { bg: "#E6F5F7", fg: "#0E6D7C" },
];

function pick(seed: string) {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length]!;
}

/** First letter of the given name, skipping the honorifics Hebrew names often
 *  start with, so "ר' יוסי כהן" shows י rather than ר. */
function initial(name: string): string {
  const cleaned = name.replace(/^(ר['׳]?|הרב|מר|גב['׳]?|משפחת)\s+/u, "").trim();
  return (cleaned || name).charAt(0) || "?";
}

export function Avatar({
  name,
  size = 48,
  square = false,
}: {
  name: string;
  size?: number;
  square?: boolean;
}) {
  const c = pick(name);
  return (
    <div
      className={square ? "avatar avatar-sq" : "avatar"}
      style={{
        width: size,
        height: size,
        background: c.bg,
        color: c.fg,
        fontSize: Math.round(size * 0.38),
      }}
      aria-hidden="true"
    >
      {initial(name)}
    </div>
  );
}
